import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ReceiptInfoVo} from '../../common/shared/api/nicolas/vo/billing/ReceiptInfoVo.interface';

/**
 * 현금 영수증 정보 조회
 *
 * Origin: pageNicolasApi.getReceiptInfo
 * API: POST /api/v1/store/receipt/info
 */
export async function postStoreReceiptInfo(
  options?: FetcherOptions
): Promise<ApiResultVo & {data: ReceiptInfoVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/receipt/info',
    {
      method: 'POST',
    },
    options
  );
  return response.data;
}
